module.exports = __webpack_public_path__ + "media/KikiR.ff17fd38.mp3";